import React from "react"
import { MessageProps } from "./message.props"
import { NotifyType } from "../../types/message"
import { MessageTypes } from "../../proto"
import {
  MessageContactDeletedNotify,
  MessageContactCreateNotify,
  MessageContactCreateButNotApprovedNotify,
  MessageMessageCreateButNotApprovedNotify,
  MessageFriendAddedButNotApprovedNotify,
  MessageNotifyCommon,
} from "./message-notify"
import WrappedMentionMessage, { MentionMessage } from "./mention-message"
import WrappedTextMessage, { TextMessage } from "./text-message"
// import WrappedOrderServerMessage, { OrderServerMessage } from "./order-server-message"
// import WrappedBannerServerMessage, { BannerServerMessage } from "./banner-server-message"
import WrappedImageMessage, { ImageMessageWithContainer } from "./image-message"
import WrappedVideoMessage, { VideoMessageWithContainer } from "./video-message"
import WrappedImagesMessage, { ImagesMessage } from "./images-message"
import WrappedVoiceMessage, { VoiceMessage } from "./voice-message/voice-message"
import WrappedFileMessage, { FileMessage } from "./file-message"
import WrappedOrderMessage, { OrderMessage } from "./order-message"
import WrappedTransMessage, { TransMessage } from "./trans-message"
import WrappedRedEnvelopeMessage, { RedEnvelopeMessage } from "./red-envelope-message"
import WrappedGameNoticeMessage, { GameNoticeMessage } from "./game-notice-message"
import WrappedBusinessCardMessage, { BusinessCardMessage } from "./business-card-message"

const NotifyComponent: React.FC<MessageProps> = (props) => {
  const { message } = props
  switch (message.notify_type) {
    case NotifyType.CONTACT_DELETED:
      return <MessageContactDeletedNotify userId={message.receiver.id} />
    case NotifyType.CONTACT_CREATED:
      return <MessageContactCreateNotify />
    case NotifyType.CONTACT_CREATED_BUT_NOT_APPROVED:
      return <MessageContactCreateButNotApprovedNotify />
    case NotifyType.MESSAGE_CREATED_BUT_NOT_APPROVED:
      return <MessageMessageCreateButNotApprovedNotify message={message} />
    case NotifyType.FRIEND_ADDED_BUT_NOT_APPROVED:
      return <MessageFriendAddedButNotApprovedNotify />
    case NotifyType.GROUP_TITLE_UPDATE:
      return <MessageNotifyCommon message={message} />
    case NotifyType.CHAT_ANNOUNCEMENTED:
      return <MessageNotifyCommon message={message} />
    case NotifyType.CHAT_CREATED:
      return <MessageNotifyCommon message={message} />
    default:
      return <MessageNotifyCommon message={message} />
  }
}

const CommonComponent: React.FC<MessageProps> = (props) => {
  const { message } = props
  // console.log('message', message)
  switch (message.type) {
    case MessageTypes.TEXT:
      return message.mention_ids ? (
        <WrappedMentionMessage {...props} />
      ) : (
        <WrappedTextMessage {...props} />
      )
    case MessageTypes.IMAGE:
      return <WrappedImageMessage {...props} />
    case MessageTypes.VIDEO://视频消息
      return <WrappedVideoMessage {...props} />
    case MessageTypes.IMAGES:
      return <WrappedImagesMessage {...props} />
    case MessageTypes.VOICE:
      return <WrappedVoiceMessage {...props} />
    case MessageTypes.FILE:
      return <WrappedFileMessage {...props} />
    case MessageTypes.ORDER:
      return <WrappedOrderMessage {...props} />
    // case MessageTypes.TRANS:
    //   return <WrappedRedEnvelopeMessage {...props} />
    case MessageTypes.NEW_TRANS:
      return <WrappedTransMessage {...props} />
    case MessageTypes.RED_PACKET:
      return <WrappedRedEnvelopeMessage {...props} />
    case  MessageTypes.GAME_NOTICE:
      return <WrappedGameNoticeMessage {...props} />
    case MessageTypes.SHARE_CARD:
      return <WrappedBusinessCardMessage {...props} />
    // case MessageTypes.ORDERSERVER:
    //   return <WrappedOrderServerMessage {...props} />
    // case MessageTypes.BANNERSERVER:
    //   return <WrappedBannerServerMessage {...props} />
    default:
      return null
  }
}

export const ReplyComponent: React.FC<MessageProps> = (props) => {
  const { message } = props
  switch (message.type) {
    case MessageTypes.TEXT:
      return message.mention_ids ? <MentionMessage {...props} /> : <TextMessage {...props} />
    case MessageTypes.IMAGE:
      return <ImageMessageWithContainer {...props} />
    case MessageTypes.VIDEO:
      return <VideoMessageWithContainer {...props} />
    case MessageTypes.IMAGES:
      return <ImagesMessage {...props} />
    case MessageTypes.VOICE:
      return <VoiceMessage {...props} />
    case MessageTypes.FILE:
      return <FileMessage {...props} />
    case MessageTypes.ORDER:
      return <OrderMessage {...props} />
    case MessageTypes.NEW_TRANS:
      return <TransMessage {...props} />
    case MessageTypes.RED_PACKET:
      return <RedEnvelopeMessage {...props} />
    case MessageTypes.GAME_NOTICE:
      return <GameNoticeMessage {...props} />
    case MessageTypes.SHARE_CARD:
      return <BusinessCardMessage {...props} />
    // case MessageTypes.ORDERSERVER:
    //   return <OrderServerMessage {...props} />
    // case MessageTypes.BANNERSERVER:
    //   return <BannerServerMessage {...props} />
    default:
      return null
  }
}

{/* NotifyComponent:  系统通知消息; CommonComponent: 普通聊天消息*/}
const Message: React.FC<MessageProps> = (props) => {
  const { message } = props
  return message.isNotify ? <NotifyComponent {...props} /> : <CommonComponent {...props} />
}
export default Message
